const styles = (theme) => ({
    actionContainer: {
      position: 'relative',
      height: 200,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    headerContainer: {
      backgroundColor: `${theme.custom.formBackground}`,
      textAlign: 'center',
      borderRadius: '10px 10px 0 0',
      '& h2': {
        color: `${theme.palette.primary.main} !important`,
        padding: '1rem 0 0.5rem 0',
        margin: 0,
      },
    },
    footerContainer: {
      backgroundColor: `${theme.custom.formBackground}`,
      textAlign: 'center',
      '& p': {
        padding: '2rem 0',
        margin: 0,
      },
    },
    divider: {
      border: `1px solid ${theme.palette.primary.main}`,
      width: '100%',
    },
  
    previewContainer: {
      width: '100%',
      maxWidth: 375,
      margin: '2rem auto',
      backgroundColor: '#000',
      borderRadius: 10,
      overflow: 'hidden',
      overflowY: 'auto',
      height: '55vh',
      scrollbarWidth: 'thin', 
      scrollbarColor: `${theme.palette.primary.light} transparent`, 
      '&::-webkit-scrollbar': {
          width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.primary.light,
          borderRadius: '10px',
      },
    },
    header: {
      position: 'relative',
      zIndex: 2,
      borderRadius: '10px 10px 0 0',
      padding: '18px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    time: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      color: 'white',
    },
    statusIcons: {
      display: 'flex',
      gap: '5px',
      color: '#000 !important',
      alignItems: 'center',
      '& span': {
        fontSize: '14px',
      },
      '& svg': {
        height: '11px',
      },
    },
    imageContainer: {
      position: 'relative',
      height: 200,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)', // Gray tint
        zIndex: 1,
      },
    },
    actionInfoContainer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      alignItems: 'flex-end',
      padding: '20px',
      zIndex: 2,
    },
    actionIcon: {
      width: 73,
      height: 73,
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      marginRight: 10,
      flexShrink: 0,
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '50%',
      },
    },
    actionTextContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    actionTitle: {
      color: 'white',
      fontSize: '24px',
      fontWeight: 400,
      marginBottom: 5,
      textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
    },
    logActionButton: {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      padding: '8px 16px',
      borderRadius: 6.566,
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontSize: '18.5px',
      fontWeight: 'bold',
      width: '100%', 
      justifyContent: 'center',
      '& svg': {
        marginRight: '4px',
      },
    },
    content: {
      padding: 20,
      paddingBottom: 50,
      wordBreak: 'break-word',
      backgroundColor: theme.custom.bgAccentColor,
    },
    description: {
      marginBottom: 20,
      fontSize: '17.5px',
      color: '#333',
    },
    noLinksText: {
      fontSize: '17.5px',
      color: theme.custom.grey80,
      textAlign: 'center',
    },
    sectionContainer: {
      marginLeft: -20,
      marginRight: -20,
      paddingTop: 20,
    },
    sectionTitle: {
      borderBottom: `1px solid ${theme.custom.grey80}`,
      fontSize: '14px',
      color: `${theme.custom.grey80}`,
      marginBottom: 10,
      textTransform: 'uppercase',
      paddingBottom: 10,
      paddingLeft: 20,
    },
    pointsContainer: {
      display: 'flex',
      justifyContent: 'center', 
      gap: 20,
    },
    pointItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // flex: 1,
    },
    pointCircle: {
      width: 86,
      height: 86,
      borderRadius: '50%',
      backgroundColor: theme.custom.lightPurple,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white',
      fontSize: '34px',
      fontWeight: 'bold',
      margin: '0 auto',
    },
    pointLabel: {
      textAlign: 'center',
      fontSize: '12px',
      color: `${theme.custom.grey80}`,
      marginTop: 5,
      textTransform: 'uppercase',
    },
    photoCredit: {
      fontSize: '12px',
      color: `${theme.custom.grey80}`,
      marginTop: 20,
    },
    videoContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        alignItems: 'center',
        width: '100%',
    },
    videoWrapper: {
        width: '100%',
        aspectRatio: '16 / 9',
    },
    previewVideo: {
        padding: "0 12px",
        width: '100%',
        height: '100%',
        border: 'none',
    },
    linkContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: '100%',
    },
    linkPreview: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        margin: "0 12px",
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.divider}`,
        overflow: 'hidden',
    },
    previewImageWrapper: {
        flexShrink: 0,
        width: 64,
        height: 64,
        borderRadius: 8,
        overflow: 'hidden',
    },
    previewImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    previewSummary: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'hidden',
    },
    previewSummaryTitle: {
        fontSize: '14px',
        fontWeight: 600,
        marginBottom: theme.spacing(0.5),
        color: theme.palette.text.primary,
    },
    previewSummaryDescription: {
        fontSize: '12px',
        color: theme.palette.text.secondary,
        wordBreak: 'break-word',
    },
    container: {
        position: 'fixed',
        width: 'auto',
        margin: '0 auto', 
    },
    navigationButtons: {
      position: 'absolute',
      top: 60,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0',
      zIndex: 2,
    },
    backButton: {
      color: 'white',
      padding: '0 18px',
    },
    shareButton: {
      color: 'white',
      padding: '0 20px',
    },
  });
  
  export default styles;
  